import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/queryKeys';
import { fetchMe } from '@/api/auth';

// Shared current-user query. Every component that needs the logged-in user reads
// through this one key, so N consumers dedupe to a single request instead of the
// refetch storm the old per-mount `/api/auth/me` calls caused.
export function useCurrentUser(options = {}) {
  return useQuery({
    queryKey: queryKeys.currentUser,
    queryFn: fetchMe,
    staleTime: 30_000,
    ...options,
  });
}
